import { CreditCard, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PricingCards, PLANS } from "@/pages/PricingPage";
import { Badge } from "@/components/ui/badge";

export default function Billing() {
  const { user } = useAuth();
  const planId = user?.plan || "free";
  const current = PLANS.find((p) => p.id === planId);

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-ink">Billing & Plans</h1>
        <p className="text-sm text-muted mt-1">Manage your AICS AGENT subscription.</p>
      </div>

      <div className="card-surface rounded-2xl p-6 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-cyber/15 flex items-center justify-center">
            <CreditCard size={22} className="text-cyber" />
          </div>
          <div>
            <p className="text-sm text-muted">Current plan</p>
            <p className="font-display font-bold text-xl text-ink capitalize" data-testid="current-plan">
              {current ? current.name : "Free Trial"}
            </p>
          </div>
        </div>
        <Badge className={`border-0 ${planId === "free" ? "bg-high/15 text-high" : "bg-secure/15 text-secure"}`}>
          {planId === "free" ? "Trial · 3 months on us" : "Active"}
        </Badge>
      </div>

      <div>
        <h2 className="font-display text-xl font-bold text-ink mb-6 text-center">Upgrade your security capacity</h2>
        <PricingCards />
      </div>
    </div>
  );
}
